import { render, staticRenderFns } from "./HospitalIncidents.vue?vue&type=template&id=4a0f90a4&"
import script from "./HospitalIncidents.vue?vue&type=script&lang=js&"
export * from "./HospitalIncidents.vue?vue&type=script&lang=js&"
import style0 from "./HospitalIncidents.vue?vue&type=style&index=0&id=4a0f90a4&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports